import { Component, h } from 'preact';

interface ChipProps {
  onClick?: (event: Event) => void;
}

export class Chip extends Component<ChipProps> {
  render(props: ChipProps) {
    return (
      <button className="btn btn-dark hi-chip" onClick={ props.onClick }>
        <i className="fas fa-times hi-chip__icon" />
        { this.props.children }
      </button>
    )
  }
}